<style lang="less">
    @import '../../../../styles/common-table-list.less';
</style>
<template>
    <div class="center-table-list"  style="position:relative;height: 100%; min-height: 726px;background: #fff;">
        <div class="table-list">
            <div class="table-list-title">
                <span class="myTitle">我的预登记</span>
                <div class="choose-group">
                    <span class="choose-group-span">预登记日期</span>
                    <Date-picker
                            v-model="dateValue"
                            format="yyyy-MM-dd"
                            type="daterange"
                            placement="bottom-end"
                            @on-change="timeChange"
                            placeholder="请选择日期"
                            style="width: 200px"
                    ></Date-picker>
                    <span class="choose-group-span">作品名称</span>
                    <i-input
                            v-model="workFullname"
                            ref="workFullnameInput"
                            :search="true"
                            @on-search="searchReset"
                            placeholder="请输入作品名称"
                            style="width: 205px"
                            class="select-input-style"
                    ></i-input>
                    <button @click="searchReset" class="btn-84 addBtn" >查询</button>
                    <!--            <button class="btn-84" style="margin:0px 30px 0px 20px">新增监测</button>-->
                </div>
            </div>
            <Row class="table-style-size">
                <i-col span="6">作品名称</i-col>
                <i-col span="6">权利权属</i-col>
                <i-col span="6">作品文件数量</i-col>
                <i-col span="6">是否提交登记</i-col>
                <i-col span="6">作品保护情况</i-col>


                <i-col span="6">提交时间</i-col>
                <i-col span="7">操作</i-col>
            </Row>

            <errorTips :state="0" v-if="loadFlag && records.length == 0"></errorTips>

            <div v-else>
                <Row v-for="(item, index) in records" :key="index" :style="{background: item.index %2 == 0 ? 'rgba(228,228,228,1)' : '#fff' }"
                     class="table-style-size table-style-body">
                        <i-col span="6" >
                            <Tooltip :content="item.workFullName" placement="top">
                                <div class="notwrap">{{item.workFullName}} </div>
                            </Tooltip>
                        </i-col>
                        <i-col span="6">{{item.copyrightType}} </i-col>
                        <i-col span="6">{{item.workFileCount}} </i-col>

                        <i-col span="6">
                            <span v-if="item.status == 'wait_identify'">否</span>
                            <span v-else>是</span>
                        </i-col>

                        <i-col span="6">
                            <Tooltip v-if="item.preRegisterStatus == 0" content="预登记证书" placement="top">
                                <img  style="width:24px;height:24px;margin:auto" src="@/assets/yw.png" alt="">
                            </Tooltip>
                            <Tooltip v-else content="预登记证书" placement="top">
                                <img  style="width:24px;height:24px;margin:auto" src="@/assets/yy.png" alt="">
                            </Tooltip>
                            <Tooltip v-if="item.status != 'identify'" content="登记证书" placement="top">
                                <img  style="width:24px;height:24px;margin:auto auto auto 15px" src="@/assets/dw.png" alt="">
                            </Tooltip>
                            <Tooltip v-else content="登记证书" placement="top">
                                <img  style="width:24px;height:24px;margin:auto auto auto 15px" src="@/assets/dy.png" alt="">
                            </Tooltip>

                        </i-col>

                        <i-col span="6">{{ item.createDate}}</i-col>
                        <i-col span="7">
                            <button @click="goDetailsid(item)" class="btn-84 addBtn" >查看详情</button>
                            <!-- <button class="btn-84 addBtn" v-if="item.subBizType != null && item.subBizType != '' && item.subBizType != 'null' && item.payStatus == 'unpay' && item.status == 'wait_identify'" @click="nowPay(item)">去支付</button>
                            <button class="btn-84 addBtn" v-if="!item.subBizType && item.payStatus == 'unpay' && item.status == 'wait_identify'" @click="payDengji(item.orderSeqNo)">申请登记</button> -->
                            <button class="btn-84 addBtn" v-if="item.payStatus == 'unpay' && item.status == 'wait_identify'" @click="payDengji(item)">一键登记</button>
                        </i-col>
                </Row>
                <div style="height:80px"></div>
                <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
        </div>
        <!-- 申请纸质登记、证书查询、证书撤销、作品变更 -->
        <myDciorderup @fatherModal="fatherModal"
                      v-if="showModal"
                      :myDciorderupTitle="myDciorderupTitle"
                      :myDciorderupPay="myDciorderupPay"
                      :myDciorderupDownloadUrl="myDciorderupDownloadUrl"
                      :dataItem="dataItem"
                      :isActivity="isActivity"
                      ref="childModal"></myDciorderup>
        <!-- 前海版权公共服务平台支付 -->
        <payDalog3 ref="payDalog3" :payOrder="payOrder" @confirm="confirm"></payDalog3>
        <payDalog3up ref="payDalog3up" :payOrder="payOrder" @confirm3up="confirm3up"></payDalog3up>
    </div>
</template>

<script>
    import errorTips from '@/views/main-components/error-tips';
    import myDciorderup from './myDci-order-Up.vue';
    import Cookies from 'js-cookie';
    import payDalog3 from '@/viewsGangAn/components/payDalog3';
    import payDalog3up from '@/viewsGangAn/components/payDalog3up';
    import {getInsuranceUrl,getShangInsurance,getPreCopyrightRegisterListGangAn} from '@/api/staticPage';
    import {getPayStatusByOrderSeqNo} from "@/api/index.js";
    import {getCopyrightRegisterInfo} from '@/api/register.js'
    export default {
        name: 'myDci',
        metaInfo: {
            title: '我的预登记|前海版权综合服务平台',
            meta: [
                {
                    // set meta
                    name: 'keyWords',
                    content:
                        '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
                },
                {
                    name: 'Description',
                    content:
                        '权利人管理,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
                }
            ]
        },
        components: {
            errorTips,
            myDciorderup,
            payDalog3,
            payDalog3up
        },
        data() {
            return {
                userInfo: Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : '',
                total: 0, //总数量
                pageNumber: 1, //当前页面
                pages: 1, //总页数
                pageSize: 9, //数据尺寸
                dateValue: [], //时间
                records: [], //登记数据
                workFullname: '', //登记名称
                loadFlag: false,//加载flag
                showModal: !1,
                dataItem: {},
                moreItem: [
                    {
                        name: '纸质版权登记',
                        engNumIndex:'paperCopyrightRegisterNum',
                        downloadUrl: 'https://file.bqj.cn/file/0490416198abb3835c162b79f47734ff.xlsx',
                        payCode: '0211'
                    },
                    {
                        name: '证书查询',
                        engNumIndex:'copyrightRegisterFindNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/9d18cda560977aa549eec53af6a8b9cf.docx',
                        payCode: '0212'
                    },
                    {
                        name: '证书撤销',
                        engNumIndex:'copyrightRegisterCancelNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/c4c45d981a9f6f1cf313b82687aa06a6.docx',
                        payCode: '0213'
                    },
                    {
                        name: '作品变更',
                        engNumIndex:'copyrightRegisterUpdateNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/0794d8ced9a57021e090312b80ba63c6.doc',
                        payCode: '0214'
                    },

                ], //登记相关操作下拉
                myDciorderupTitle: '',//申请类型
                myDciorderupDownloadUrl: '', //申请类型模板链接
                myDciorderupPay: '', //申请类型支付code
                serviceList: [
                    {name: '全部', subBizType: 'all'},
                    {name: '电子登记', subBizType: '0202,0201'},
                    {name: '纸质版权登记', subBizType: '0211'},
                    {name: '证书查询', subBizType: '0212'},
                    {name: '证书撤销', subBizType: '0213'},
                    {name: '作品变更', subBizType: '0214'},
                ], //服务类别
                serviceValue: 'all', //下拉框当前选中
                subBizType: '', //请求数据的类型
                isActivity: false, //是否活动
                insuranceId:"",
                currentIndex:null,
                yes: require('../../insurance/images/yes.png'),
                no:require("../../insurance//images/no.png"),
                dis:require("../../insurance//images/disCheck.png"),
                payOrder: {},
                ByOrderSeqNo: {}
            };
        },
        created() {
        },
        mounted() {
            this.getPreCopyrightRegisterListGangAn();
        },
        methods: {
            // 申请登记
            payDengji(details) {
                let that = this
                if (details.subBizType) {
                    this.getPayStatusByOrderSeqNo(details)
                } else {
                    let data = {
                        orderSeqNo: details.orderSeqNo
                    };
                    getCopyrightRegisterInfo(data).then(res => {
                        if (res.code == 200) {
                            this.$refs.payDalog3up.configGetBzPrice(details.orderSeqNo, JSON.parse(res.result.copyrightOrderInfo.obligees))
                        }
                    }, (err) => {
                        toast('网络断开连接，请重试')
                    })
                    // this.$refs.payDalog3up.configGetBzPrice(details.orderSeqNo)
                }

            },
            //有没有支付成功
            getPayStatusByOrderSeqNo(details) {
                let that = this
                let data = {
                    orderSeqNo: details.orderSeqNo,
                    bizType: '02',
                    subBizType: details.subBizType,
                }
                getPayStatusByOrderSeqNo(data).then( res => {
                    if (res.result.payStatus == 'cancel' && details.status == 'wait_identify') {
                        that.$refs.payDalog3up.configGetBzPrice(details.orderSeqNo)
                    } else {
                        that.$refs.payDalog3.configGetBzPrice3(details,true)
                    }
                })
            },
            nowPay(item) {
                this.$refs.payDalog3.configGetBzPrice3(item,true)
            },
            confirm(e){
                // toast('申请成功')
                this.getPreCopyrightRegisterListGangAn()
            },
            confirm3up(e){
                this.$refs.payDalog3.configGetBzPrice2(e)
            },
            confirm3up2(e){
                this.getPreCopyrightRegisterListGangAn()
            },
            /*********编辑********/
            bianjiData(item){
                const newHref = this.$router.resolve({name: `/copyrightRegistration?id=${item.orderSeqNo}&regType=17`})
                window.open(newHref.location.name,'_blank')
            },
            /*********跳转详情页********/
            goDetailsid(item) {
                const newHref = this.$router.resolve({name: `/copyrightDetails?id=${item.orderSeqNo}&regType=17`})
                window.open(newHref.location.name,'_blank')
            },
            //下载电子发票
            lookInsuranceInvoice(data){
                getShangInsurance(data.orderSeqNo).then(res=>{
                    if(res.code == 200){
                        window.open(res.result, '_blank')
                    }else{
                        toast(res.message)
                    }
                })
            },
            //查看保单
            lookInsurance(url){
                window.open(url, '_blank')
            },
            //上保险
            shangbaoxian(val){
                let data={
                    refSeqNo:val.orderSeqNo,
                    type:0
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        window.open(res.result)
                        toast("成功上保险")
                        // this.applyBillFlagRegister = false;
                    }else{
                        // this.applyBillFlagRegister = false;
                        toast(res.message)
                    }
                })
            },
             //去了解上保险险情
            goInsurance(){
                this.$router.push({
                    path:'/insurance'
                })
            },
            //选择作品上保险
            //单选
            selectItem(index,data){
                this.currentIndex=index;
                console.log(data)
                this.insuranceId=data.orderSeqNo
            },
            insuranceCert(){
                let data={
                    refSeqNo:this.insuranceId,
                    type:0
                }
                if(this.insuranceId){
                    getInsuranceUrl(data).then(res=>{
                        if(res.code == 200){
                            window.open(res.result)
                            toast("成功上保险")
                             this.applyBillFlagRegister = false;
                        }else{
                             this.applyBillFlagRegister = false;
                            toast(res.message)
                        }
                    })
                }else{
                    toast("请选择要上保险的订单")
                }
            },
            /*********获取列表数据********/
            getPreCopyrightRegisterListGangAn() {
                this.$refs['workFullnameInput'].blur();

                let data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    createDateStart: this.dateValue[0],
                    createDateEnd: this.dateValue[1],
                    workFullName: this.workFullname,
                    sort: 'createDate',
                    order: 'desc'
                };

                getPreCopyrightRegisterListGangAn(data).then(
                    res => {
                        if (res.code == 200) {
                            let result = res.result;
                            this.total = result.total - 0;
                            this.pages = result.pages;
                            this.records = result.records;
                            this.loadFlag = true;
                        } else {
                            toast(res.message);
                        }
                    },
                    err => {
                        toast('网络断开连接，请重试');
                    }
                );
            },

            /*********时间改变事件********/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset();
            },

            /*********页数改变事件********/
            changepage(index) {
                this.pageNumber = index;
                this.getPreCopyrightRegisterListGangAn();
            },

            /*********搜索重置事件********/
            searchReset() {
                this.pageNumber = 1;
                this.getPreCopyrightRegisterListGangAn();
            },

            /*********搜索清空事件********/
            searchEmpty() {
                this.serviceValue = 'all';
                this.subBizType = '';
                this.dateValue = [];
                this.workFullname = '';
                this.pageNumber = 1;
                this.getPreCopyrightRegisterListGangAn();
            },
            /*********弹框********/
            shopModal(item, index) {
                console.log(item);
                let _this = this;
                let moreItem = _this.moreItem;
                _this.myDciorderupTitle = moreItem[index].name;
                _this.myDciorderupDownloadUrl = moreItem[index].downloadUrl;
                _this.myDciorderupPay = moreItem[index].payCode; //申请类型支付code

                //用于判断是否有权益次数，控制附件服务的扣费是否显示
                if(item.rights && item.rights!=''){
                    if(item.rights[moreItem[index].engNumIndex] > 0){
                        this.isActivity = true;
                    }
                    else{
                        this.isActivity = false;
                    }
                }
                else{
                    this.isActivity = false;
                }

                _this.dataItem = item;
                _this.showModal = !0;
            },
            fatherModal(flag) {
                let _this = this;
                _this.showModal = !1;
                if (flag == 'success') {
                    this.searchEmpty();
                }
            },

            selectType(val) {
                console.log('这是获取的类型', val)
                this.subBizType = val == 'all' ? '' : val;
                this.pageNumber = 1;
                this.getPreCopyrightRegisterListGangAn();
            },
        }
    };
</script>
<style scoped lang="less">
    .showphotow {
        display: inline-block;
        height: 100%;
        position: relative;
        /*margin-left: 20px;*/

        .showdiasy {
            position: absolute;
            top: 35px;
            left: 0;
            background: #fff;
            box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
            border-radius: 4px;
            z-index: 777;
            width: 110px;
            display: none;

            p {
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                font-size: 12px;
                background-color: #fff;
                color: #929292;
            }

            a {
                color: #929292;
            }

            a:hover {
                color: #4e4e4e;
            }

            p:hover {
                background-color: #f7f9fb;
                color: #4e4e4e;
            }
        }

        &:hover {
            .showdiasy {
                display: block;
            }
        }
    }

    .no_click_btn{
        margin: 0 15px;
        padding: 0 5px;
        height: 33px;
        display: inline-block;
        line-height: 33px;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        cursor: not-allowed;
    }
.caozuo-box{
    margin-bottom: 12px;
    background: #fff;
    display:flex;
    flex-direction:row;
    align-items:center;
    .xuqi_btn{
        margin-right: 10px;
        width: 84px;
        height: 33px;
        background: #ffd800;
        border: 1px solid #ffd800;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        line-height: 33px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        border: none;
        outline: none;
    }
}
.myTitle{
        font-size: 18px !important;
        font-weight: 700;
        position: relative;
        z-index: 2;
        &::before{
            content: '';
            position: absolute;
            width: 50px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 3px;
            z-index: -1;
        }
    }
    .addBtn{
        background: #fff !important;
        color: #2196F3 !important;
        border: solid 1px #2196F3 !important;
        border-radius: 4px !important;
    }
    .father-box-input{
        display: flex !important;
        align-items: center;
    }
</style>
